import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, InputGroup, Spinner } from 'react-bootstrap';
import { FaUser, FaEnvelope, FaCheck, FaUserTag } from 'react-icons/fa';
import { NotificationContext } from '../../contexts/notification-context';
import usuariosService from '../../api/usuariosService';
import './index.css';
import { useNavigate, useParams } from 'react-router-dom';

const CadastrarUsuario = () => {
  const { addNotification } = React.useContext(NotificationContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [ativo, setAtivo] = useState(true);
  const [perfil, setPerfil] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      const carregarUsuario = async () => {
        try {
          setLoading(true);
          const usuario = await usuariosService.obter(id); 
          setNome(usuario.nome);
          setEmail(usuario.email);
          setAtivo(usuario.ativo);
          setPerfil(usuario.perfilId.toString());
        } catch (err) {
          console.error('Erro ao carregar usuário:', err);
          addNotification('danger', 'Erro ao carregar usuário. Por favor, tente novamente.');
        } finally {
          setLoading(false);
        }
      };

      carregarUsuario();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'nome':
        setNome(value);
        break;
      case 'email':
        setEmail(value);
        break;
      case 'ativo':
        setAtivo(value === 'true');
        break;
      case 'perfil':
        setPerfil(value);
        break;
      default:
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!nome || !email || !perfil) {
      addNotification('danger', 'Por favor, preencha todos os campos.');
      setLoading(false);
      return;
    }

    const usuarioData = {
      nome,
      email,
      ativo,
      perfilId: parseInt(perfil, 10),
    };

    try {
      if (id) {
        await usuariosService.atualizar(id, usuarioData);
        addNotification('success', 'Usuário alterado com sucesso!');
      } else {
        await usuariosService.inserir(usuarioData);
        setNome('');
        setEmail('');
        setPerfil('');
        addNotification('success', 'Usuário cadastrado com sucesso!');
      }
      navigate('/usuarios'); // Redireciona para a lista de usuários
    } catch (err) {
      console.error('Erro ao salvar usuário:', err);
      addNotification('danger', `Erro ao ${id ? 'alterar' : 'cadastrar'} usuário. Por favor, tente novamente.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cadastrar-usuario-container">
      <Card className="cadastrar-usuario-card shadow-sm">
        <Card.Body>
          <Card.Title className="text-center mb-4">{id ? 'Editar Usuário' : 'Cadastrar Usuário'}</Card.Title>
          <hr />
          <Form onSubmit={handleSubmit} className="cadastrar-usuario-form">
            <Row>
              <Col md={6} sm={12}>
                <Form.Group controlId="nome">
                  <Form.Label>Nome</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaUser />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="nome"
                      value={nome}
                      onChange={handleChange}
                      required
                      placeholder="Digite o nome do usuário"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={6} sm={12}>
                <Form.Group controlId="email">
                  <Form.Label>Email</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaEnvelope />
                    </InputGroup.Text>
                    <Form.Control
                      type="email"
                      name="email"
                      value={email}
                      onChange={handleChange}
                      required
                      placeholder="Digite o email do usuário"
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={6} sm={12}>
                <Form.Group controlId="perfil">
                  <Form.Label>Perfil</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaUserTag />
                    </InputGroup.Text>
                    <Form.Control
                      as="select"
                      className="form-select"
                      name="perfil"
                      value={perfil}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Selecione o perfil</option>
                      <option value="1">Administrador</option>
                      <option value="2">Agendamento</option>
                      <option value="3">Profissional</option>
                    </Form.Control>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={6} sm={12}>
                <Form.Group controlId="ativo">
                  <Form.Label>Ativo</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaCheck />
                    </InputGroup.Text>
                    <Form.Control
                      as="select"
                      className="form-select"
                      name="ativo"
                      value={ativo ? 'true' : 'false'}
                      disabled={!id}
                      onChange={handleChange}
                      required
                    >
                      <option value="true">Ativo</option>
                      <option value="false">Inativo</option>
                    </Form.Control>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col className="text-start"> 
                  <Button
                  variant="primary"
                  type="submit"
                  disabled={loading}
                  className="me-2"
                  >
                  {loading ? (
                      <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      />
                  ) : (
                      id ? 'Alterar' : 'Cadastrar'
                  )}
                  </Button>
                  <Button variant="secondary" onClick={() => navigate('/lista-usuarios')}>
                  Voltar
                  </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CadastrarUsuario;
